import React from 'react';
import styled from 'styled-components/macro';

import Box from 'components/elements/Box';
import P from '../../elements/p';

import colors from 'styles/themes/colors';

const CheckboxContainer = styled('svg')`
  display: block;
  margin-right: 0.625em;
  fill: transparent;
  width: 1.25em;
  height: 1.25em;
  /** Fix a bug on iOS where the bottom line of the SVG doesn't show */
  transform: translate3d(0, 0, 0);
`;

const CheckboxBackground = styled('rect')`
  fill: ${colors.White};
  stroke: ${colors.BrownishGrey};
  stroke-width: 1;
`;

const Checkbox: React.FC<{
  text: string;
  isChecked: boolean;
  onClick?: any;
}> = ({ text, isChecked, onClick }) => (
  <Box display="flex" alignItems="center">
    <CheckboxContainer viewBox={'0 0 20 20'} onClick={onClick}>
      <CheckboxBackground width="16" height="16" x="1" y="1" rx="3" ry="3" />
      {isChecked && (
        <polygon
          fill={isChecked ? colors.AccentGreen : colors.White}
          fillRule="nonzero"
          style={{ transform: 'translate(-3px, -3px)' }}
          width="16"
          points="17.666 7.293 19.08 8.707 10.373 17.414 6.293 13.334 7.707 11.92 10.373 14.586"
        />
      )}
    </CheckboxContainer>

    <P my={0} color={colors.NightBlue} fontWeight="600" lineHeight="19px">
      {text}
    </P>
  </Box>
);

export default Checkbox;
